import { LightbulbIcon } from "lucide-react";

/**
 * Dark founder-tip card with an amber label.
 *
 * Note the registered-address screen uses a different treatment for the same
 * idea (yellow-tinted fill, white 18px text); this is the variant used by the
 * accounting and audit screens.
 */
export function FounderTipCard({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex w-full flex-col items-start gap-4 rounded-3xl bg-[#0E1116] p-6 outline outline-1 -outline-offset-1 outline-[#30363D]">
      <div className="flex items-center gap-2">
        <LightbulbIcon aria-hidden className="h-4 w-4 text-[#FBBF24]" />
        <span className="font-inter text-sm font-bold text-[#FBBF24]">Founder tip</span>
      </div>
      <p className="font-inter text-[13px] leading-[19.5px] text-[#9CA3AF]">{children}</p>
    </div>
  );
}
